import AllSensorsProvider from "./AllSensorsProvider";
import EnvironmentalProvider from "./EnvironmentalProvider";
import HotSpotsProvider from "./HotSpotsProvider";
import HydroProvider from "./HydroProvider";
import IndexesProvider from "./IndexesProvider";
import MeshProvider from "./MeshProvider";
import MeteoInfoProvider from "./MeteoInfoProvider";
import MobilityProvider from "./MobilityProvider";
import ParkingProvider from "./ParkingProvider";
import PublicParkingProvider from "./PublicParkingProvider";
import SensorTypesProvider from "./SensorTypesProvider";
import VariablesProvider from "./VariablesProvider";
import WeatherProvider from "./WeatherProvider";

const tilesToProviders = {
  environment: EnvironmentalProvider,
  hydro: HydroProvider,
  meteo: MeteoInfoProvider,
  all: AllSensorsProvider,
  // indexes: MeteoInfoProvider,
  weather: WeatherProvider,
  sensorTypes: SensorTypesProvider,
  parking: ParkingProvider,
  publicParking: PublicParkingProvider,
  hotSpots: HotSpotsProvider,
  info: IndexesProvider,
  mesh: MeshProvider,
  variables: VariablesProvider,
  mobility: MobilityProvider,
};

const AppProviders = ({ children, features }) => {
  return features.reduce((acc, feature) => {
    const Provider = tilesToProviders[feature];
    if (Provider) {
      return <Provider>{acc}</Provider>;
    }
    return acc; // If no matching provider, just return accumulated children
  }, children);
};

export default AppProviders;
